(() => {
  if (window.__vonnPolish) return;
  window.__vonnPolish = true;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const animated = new Set();
  const menus = new WeakSet();
  const accordions = new WeakSet();
  let observer;
  const run = (el, frames, duration = 480) => {
    if (motion.matches || !el.animate || el.closest('.shopify-design-mode')) return;
    const a = el.animate(frames, {duration, easing:'cubic-bezier(.22,1,.36,1)'});
    animated.add(a);
    a.finished.then(() => animated.delete(a), () => animated.delete(a));
  };
  const revealSelector = '.vn-section-head,.vn-about-editorial__photo,.vn-about-editorial__story,.vp-heading,.vq-page-intro';
  function init(scope = document) {
    scope.querySelectorAll('.vn-desktop-nav a,.vn-mobile-menu nav a').forEach(link => {
      const url = new URL(link.href, location.href);
      const same = url.origin === location.origin && url.pathname.replace(/\/$/,'') === location.pathname.replace(/\/$/,'');
      if (same) link.setAttribute('aria-current','page');
      else link.removeAttribute('aria-current');
    });
    scope.querySelectorAll('.vn-mobile-menu').forEach(menu => {
      if (menus.has(menu)) return;
      menus.add(menu);
      menu.addEventListener('toggle', () => {
        if (menu.open) run(menu.querySelector('nav'),[{opacity:0,transform:'translateY(-6px)'},{opacity:1,transform:'translateY(0)'}],220);
      });
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); }
      });
      menu.querySelectorAll('nav a').forEach(link => link.addEventListener('click', () => {menu.open = false;}));
    });
    scope.querySelectorAll('.vn-faq details,.vn-offer-clean details').forEach(details => {
      if (accordions.has(details)) return;
      accordions.add(details);
      details.addEventListener('toggle', () => {
        const answer = details.querySelector('.vn-answer,.vn-benefits');
        if (details.open && answer) run(answer,[{opacity:0,transform:'translateY(-4px)'},{opacity:1,transform:'translateY(0)'}],220);
      });
    });
    if (motion.matches || !('IntersectionObserver' in window)) return;
    observer ||= new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if (seen.has(entry.target)) return;
        seen.add(entry.target);
        run(entry.target,[{opacity:.35,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}]);
      });
    }, {threshold:.12});
    scope.querySelectorAll(revealSelector).forEach(el => {
      if (!seen.has(el) && !el.closest('[data-vr-reveal]')) observer.observe(el);
    });
  }
  document.addEventListener('click', event => {
    document.querySelectorAll('.vn-mobile-menu[open]').forEach(menu => {if (!menu.contains(event.target)) menu.open=false;});
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(revealSelector).forEach(el => observer?.unobserve(el));
  });
  motion.addEventListener('change', () => {
    observer?.disconnect();
    if (motion.matches) {animated.forEach(a => a.cancel());animated.clear();}
    else init();
  });
  init();
})();
(() => {
  const allowed = matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  const controllers = new Map();
  function attach(hero) {
    if (controllers.has(hero) || !allowed.matches) return;
    const glow = document.createElement('span');
    glow.className = 'vn-pointer-glow';
    glow.setAttribute('aria-hidden','true');
    hero.append(glow);
    const aborter = new AbortController();
    let frame = 0, x = 0, y = 0, targetX = 0, targetY = 0, active = false;
    function paint() {
      frame = 0;
      x += (targetX - x) * .12;
      y += (targetY - y) * .12;
      glow.style.transform = 'translate3d(' + (x - 280) + 'px,' + (y - 280) + 'px,0)';
      if (active && Math.hypot(targetX - x,targetY - y) > .3) frame = requestAnimationFrame(paint);
    }
    function move(event) {
      if (event.pointerType !== 'mouse') return;
      const rect = hero.getBoundingClientRect();
      targetX = event.clientX - rect.left;
      targetY = event.clientY - rect.top;
      if (!active) {x = targetX; y = targetY; active = true; glow.setAttribute('data-active','');}
      if (!frame) frame = requestAnimationFrame(paint);
    }
    function leave() {
      active = false;
      glow.removeAttribute('data-active');
      cancelAnimationFrame(frame); frame = 0;
    }
    hero.addEventListener('pointermove',move,{passive:true,signal:aborter.signal});
    hero.addEventListener('pointerleave',leave,{passive:true,signal:aborter.signal});
    window.addEventListener('blur',leave,{signal:aborter.signal});
    controllers.set(hero,() => {leave();aborter.abort();glow.remove();});
  }
  function init(scope = document) {
    if (scope.matches?.('.vn-hero')) attach(scope);
    scope.querySelectorAll('.vn-hero').forEach(attach);
  }
  function clear(scope) {
    controllers.forEach((dispose,hero) => {
      if (!scope || scope.contains(hero)) {dispose();controllers.delete(hero);}
    });
  }
  allowed.addEventListener('change',() => {clear();if (allowed.matches) init();});
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:section:unload',event => clear(event.target));
  init();
})();
